<template>
    <v-snackbar
        :model-value="notification.show"
        :timeout="notification.timeout"
        :color="notification.type"
        location="bottom right"
        @update:model-value="hideNotification"
    >
        <v-icon v-if="notification.type === 'error'" color="white" class="mr-2"> mdi-alert-circle-outline </v-icon>
        <v-icon v-if="notification.type === 'info'" color="white" class="mr-2"> mdi-information-outline </v-icon>

        <span>{{ notification.message }}</span>

        <template #action>
            <v-btn
                v-if="notification.action"
                outlined
                color="white"
                class="ml-2"
                :data-sentry-label="notification.action.label"
                @click="notificationAction(notification.action.data)"
            >
                {{ notification.action.label }}
            </v-btn>
            <v-btn v-else text icon color="white" data-sentry-label="Ukrywanie powiadomienia" @click="hideNotification">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script setup>
/*
    Organization / ordering applied:
    1. Imports
    2. Props / Emits
    3. Constants
    4. Stores & top-level services
    5. Reactive state (refs/reactive)
    6. Validation rules & setup
    7. Computed
    8. Handlers / methods
    9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'

import { useCommonStore } from '@/stores'

// 2. Props / Emits
// none

// 3. Constants
// none

// 4. Stores & top-level services
const commonStore = useCommonStore()

// 5. Reactive state (refs/reactive)
// none

// 6. Validation rules & setup
// none

// 7. Computed
const notification = computed(() => {
    return commonStore.notification
})

// 8. Handlers / methods
function hideNotification() {
    commonStore.hideNotification()
}

function notificationAction(action) {
    action === 'reload' ? window.location.reload(true) : (window.location.href = action)
}

// 9. Helpers / lifecycle
// none
</script>
